import type {OwnerConnectionState,OwnerReadModelSnapshot} from './product-types';
import {ownerOrderFiltersForBusinessDate} from './stage03-view-model';
import {timeLabel} from './owner-v3-model';
import {Hint,V3Card} from './owner-v3-ui';

export function syncedOrderCounts(snapshot:OwnerReadModelSnapshot|null){
  const date=ownerOrderFiltersForBusinessDate(snapshot?.store?.businessDate).businessDate;
  if(!snapshot||date==='ALL')return null;
  const counts={'待處理':0,'進行中':0,'可取餐':0};
  for(const order of snapshot.orders??[]){
    if(order.businessDate!==date)continue;
    const status=order.fulfillmentLabel;
    if(status==='待處理'||status==='進行中'||status==='可取餐')counts[status]++;
  }
  return {date,counts,total:counts.待處理+counts.進行中+counts.可取餐};
}

export function SyncedOrdersCard({snapshot,connection,onOrders,onReports}:{snapshot:OwnerReadModelSnapshot|null;connection?:OwnerConnectionState;onOrders:()=>void;onReports:()=>void}){
  const value=syncedOrderCounts(snapshot);
  const stale=connection==='OFFLINE_READONLY'||connection==='ERROR'||connection==='PERMISSION_DENIED'||connection==='STALE'||connection==='UNKNOWN';
  return <V3Card title="已同步的當日訂單">
    {value?<>
      <p className="v3-muted">營業日 {value.date}</p>
      {Object.entries(value.counts).map(([label,count])=><div className="v3-list-row" key={label}><span>{label}</span><strong>{count} 張</strong></div>)}
      {value.total===0?<Hint>已同步紀錄未見當日未完成訂單。</Hint>:null}
      <p className="v3-muted">資料讀取時間：{timeLabel(snapshot?.observedAt)}。{stale?'目前未能取得新資料，保留上次讀回。':''}</p>
    </>:<Hint>訂單或營業日資料尚未提供，暫時未能計算。</Hint>}
    <Hint>只計已同步且營業日、交收狀態明確的訂單；未上傳資料不包括在內。較早及日期未明的未完成單可到日結列表核對。</Hint>
    <button className="v3-full-row" onClick={onOrders}>查看訂單</button>
    <button className="v3-full-row" onClick={onReports}>前往報表／日結</button>
  </V3Card>;
}
